/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import SoundCanvas from './SoundCanvas';
import './App.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function App () {
  useEffect(() => {
    document.title = 'Digitales Orchesterlabor';
    const myDescription = 'Digitales Orchesterlabor';
    const description = document.querySelector('meta[name="description"]');
    if (description) {
      description.content = myDescription;
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = myDescription;
      document.head.appendChild(meta);
    }
  }, []);

  return (
    <div className="container-fluid" style={{ padding: 10 }}>
      {/* <h1>Digitales Orchesterlabor</h1> */}
      <SoundCanvas background/>
    </div>
  );
};

export default App;
